export default "__VITE_ASSET__DJGj70O4__"